module.exports = __webpack_public_path__ + "img/franklin.ef1a1fed.jpg";